import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import type { ToolResultSummary } from '../../agent.utility';

/**
 * Reusable, leak-safe renderer for a tool's output — replaces the old raw JSON dump.
 * It is intentionally generic: any tool that previously rendered `output | json` can
 * use this. Sanitization lives in `AgentUtility.summarizeToolResult`, so this
 * component stays a dumb presenter.
 */
@Component({
  selector: 'agent-tool-result-summary',
  standalone: true,
  templateUrl: './tool.result.summary.component.html',
  styleUrls: ['./tool.result.summary.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AgentToolResultSummaryComponent {

  public readonly $summary = input.required<ToolResultSummary>({ alias: 'summary' });
}
